import React from 'react';
import styled from 'styled-components';
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Select,
  Spin,
  Divider,
  Card,
  Typography,
  Tabs,
  AutoComplete,
  Upload,
  Checkbox,
  Space,
  InputNumber,
  Switch,
  DatePicker,
  Tooltip
} from 'antd';
import {
  CloseCircleFilled,
  CheckOutlined,
  CloseOutlined,
  BellOutlined,
  TeamOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  DeleteFilled,
  PlusOutlined
} from '@ant-design/icons';
import moment from 'moment';
import { ButtonSquare } from 'src/components/elements/Button';
import dropImage from 'src/static/icons/carImageUpload/placeholder.png';
import Resizer from 'react-image-file-resizer';
import { Form } from '@ant-design/compatible';
import Notify from 'src/components/meta/Notification';
import Highlighter from 'react-highlight-words';

const getDateTime = () => {
  let tempDate = new Date();
  let date =
    tempDate.getFullYear() +
    '-' +
    (tempDate.getMonth() + 1) +
    '-' +
    tempDate.getDate() +
    ' ' +
    tempDate.getHours() +
    ':' +
    tempDate.getMinutes() +
    ':' +
    tempDate.getSeconds();
  const currDate = 'Current Date= ' + date;
  this.setState({ reportStartDate: currDate });
};
const { Title } = Typography;
const { Column } = Table;
const FormItem = Form.Item;

const { TabPane } = Tabs;

const { Option } = Select;
const Cards = styled(Card)`
  .ant-card-body {
    display: none !important;
  }
`;
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    color: white !important;
    background: #0e3b50 !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s;
    font-weight: 500;
    color: #525f7f;
    font-size: 15px;
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: 0px solid #f0f0f0 !important;
    content: '';
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;
const StyledInput = styled(Input)`

  padding-left: 1.2em !important;
  height: 47px !important;
  border-right-width: 0px !important;
    box-shadow:none !important;
  background-color: white!important;
  background-image: none;
  border: none;
  border: 0px solid black !important;
  border-bottom: 1px solid lightgrey !important;
  border-radius: 0px;
  color: black!important;
  //box-shadow: rgba(0, 0, 0, 0.11) 2px 8px 13px 5px !important;
  :placeholder {
    color: lightgrey !important;
  }
  :hover {
    border-color: red !important;
    border-right-width: 0px !important;
    box-shadow:none !important;
}
  :active{
    border-color: red !important;
    border-right-width: 0px !important;
     box-shadow:none !important;
   
  }
  :focus{
    border-color: red !important;
    border-right-width: 0px !important;
     box-shadow:none !important;
   
  }
  }
`;
const StyledInputNumber = styled(InputNumber)`
  font-weight: 500 !important;
  color: #525f7f !important;
  font-size: 15px !important;
  cursor: not-allowed;
  .ant-input-number-disabled .ant-input-number-input {
    font-weight: 500 !important;
    color: #525f7f !important;
    font-size: 15px !important;
    cursor: not-allowed;
  }
`;
const StyledSelect = styled(Select)`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    position: relative;
    background-color: #ffffff;
    /* border: 1px solid #e9e9e9; */
    height: 45px !important;
    padding: 5px 11px !important;
    border: 1px solid white !important;
    border-radius: 2px;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .ant-select-multiple .ant-select-selector {
    height: 45px !important;
  }
  border: 1px solid lightgrey;
  border-radius: 0em !important;
  height: 47px !important;
  box-shadow: none !important;
  :hover {
    border-color: red !important;

    box-shadow: none !important;
  }
  :active {
    border-color: red !important;

    box-shadow: none !important;
  }
  :focus {
    border-color: red !important;

    box-shadow: none !important;
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-color: red !important;
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: none !important;
  }
`;
const dateFormat = 'YYYY/MM/DD HH:mm:ss';
const customFormat = value => `custom format: ${value.format(dateFormat)}`;
const onChangeDate = (date, dateString) => {
  console.log(date, dateString);
};
function callback(key) {
  console.log(key);
}
function onChange(e) {
  console.log(`checked = ${e.target.checked}`);
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class AddStockForm extends React.Component {
  state = {
    manualInput: this.props.editStock
      ? this.props.editStock.manualInput
      : false,
    previewVisible: false,
    previewImage: '',
    previewTitle: '',
    fileList: [],
    stockNumbers: [],
    years: [],
    makes: [],
    variants: [],
    models: [],
    mileages: [],
    retailIncs: [],
    intColours: [],
    extColours: [],
    capacityCCs: [],
    bodyTypes: [],
    engineSizes: [],
    unladenWeights: [],
    vehicleDrives: [],
    axles: [],
    doors: [],
    cylinders: [],
    passengers: [],
    vehicleStockNumbers: [],
    vehicleStockNumber: undefined,

    intColour: undefined,
    extColour: undefined,
    passenger: undefined,
    retailPriceIncl: undefined,
    cylinder: undefined,
    unladenWeight: undefined,
    axle: undefined,
    vehicleDrive: undefined,
    engineSize: undefined,
    bodyType: undefined,
    capacityCC: undefined,
    stockNumber: undefined,
    modelYear: undefined,
    make: undefined,
    mileage: undefined,
    series: undefined,
    branchImage: undefined,
    frontLeftImage: undefined,
    frontImage: undefined,
    frontRightImage: undefined,
    rightSideImage: undefined,
    wheelsImage: undefined,
    backRightImage: undefined,
    backImage: undefined,
    backLeftImage: undefined,
    leftSideImage: undefined,
    bootImage: undefined,
    frontSeatImage: undefined,
    backSeatImage: undefined,
    dashPassengerImage: undefined,
    dashDriverImage: undefined,
    dashDriverSideImage: undefined,
    radioImage: undefined,
    radioCloseImage: undefined,
    gearsImage: undefined,
    steeringImage: undefined,
    spareKeyImage: undefined,
    curDT: new Date().toLocaleString()
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    });
  };
  handleChange = ({ fileList }) => this.setState({ fileList });
  selectManual = checked => {
    this.setState({
      manualInput: !this.state.manualInput
    });
  };
  selectStockNumber = stockNumber => {
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findyears?stockNumber=' +
        stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        years: result.years,
        modelYear: undefined,
        stockNumber: stockNumber
      });
    });
  };
  selectYear = (
    modelYear,
    make,
    series,
    mileage,
    capacityCC,
    bodyType,
    engineSize,
    vehicleDrive,
    unladenWeight,
    axle,
    door,
    cylinder,
    date,
    intColour,
    extColour,
    retailPriceIncl,
    vehicleStockNumber
  ) => {
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findmakes?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        makes: result.makes,
        modelYear: modelYear,
        make: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findmodels?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({ models: result.models, make: make, series: undefined });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findvariants?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        variants: result.variants,
        series: series,
        modelDesc: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findmileages?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        mileages: result.mileages,

        mileage: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findcapacityccs?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        capacityCCs: result.capacityCCs,
        mileage: mileage,
        capacityCC: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findvehicledrives?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        vehicleDrives: result.vehicleDrives,
        capacityCC: capacityCC,
        vehicleDrive: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findvehicledrives?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        engineSizes: result.engineSizes,
        bodyType: bodyType,
        engineSize: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findbodytypes?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        bodyTypes: result.bodyTypes,
        bodyType: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findvehicledrives?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        vehicleDrive: result.vehicleDrive,
        engineSize: engineSize,
        vehicleDrive: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findunladenweights?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        unladenWeights: result.unladenWeights,
        vehicleDrive: vehicleDrive,
        unladenWeight: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findaxles?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        axles: result.axles,
        unladenWeight: unladenWeight,
        axle: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/finddoors?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        doors: result.doors,
        axle: axle,
        door: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findcylinders?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        cylinders: result.cylinders,
        door: door,
        cylinder: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findpassengers?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        passengers: result.passengers,
        cylinder: cylinder,
        passenger: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findretailincs?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        retailIncs: result.retailIncs,

        retailPriceIncl: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findvehiclestocknumbers?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        vehicleStockNumbers: result.vehicleStockNumbers,

        vehicleStockNumber: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findextcolours?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        extColours: result.extColours,

        extColour: undefined
      });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findintcolours?stockNumber=' +
        this.state.stockNumber,
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving makes'
        });
      const result = await res.json();
      this.setState({
        intColours: result.intColours,

        intColour: undefined
      });
    });
  };
  //selectMake = (make) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findmodels?stockNumber=" +
  //      this.state.stockNumber,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({ models: result.models, make: make, series: undefined });
  //  });
  //};
  //selectModel = (series) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findvariants?stockNumber=" +
  //      this.state.stockNumber,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      variants: result.variants,
  //      series: series,
  //      modelDesc: undefined,
  //    });
  //  });
  //};
  //selectVariant = (modelDesc) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findmileages?stockNumber=" +
  //      this.state.stockNumber,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      mileages: result.mileages,
  //      modelDesc: modelDesc,
  //      mileage: undefined,
  //    });
  //  });
  //};
  //selectMileage = (mileage) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findcapacityccs?stockNumber=" +
  //      this.state.stockNumber,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      capacityCCs: result.capacityCCs,
  //      mileage: mileage,
  //      capacityCC: undefined,
  //    });
  //  });
  //};
  //selectCapacityCC = (capacityCC) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findvehicledrives?stockNumber=" +
  //      this.state.stockNumber,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      vehicleDrives: result.vehicleDrives,
  //      capacityCC: capacityCC,
  //      vehicleDrive: undefined,
  //    });
  //  });
  //};
  //selectBodyType = (bodyType) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findvehicledrives?stockNumber=" +
  //      this.state.stockNumber,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      engineSizes: result.engineSizes,
  //      bodyType: bodyType,
  //      engineSize: undefined,
  //    });
  //  });
  //};
  //selectEngineSize = (engineSize) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findvehicledrives?stockNumber=" +
  //      this.state.stockNumber,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      vehicleDrive: result.vehicleDrive,
  //      engineSize: engineSize,
  //      vehicleDrive: undefined,
  //    });
  //  });
  //};
  //selectVehicleDrive = (vehicleDrive) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findunladenweights?vehicledrive=" +
  //      vehicleDrive +
  //      "&year=" +
  //      this.state.modelYear,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      unladenWeights: result.unladenWeights,
  //      vehicleDrive: vehicleDrive,
  //      unladenWeight: undefined,
  //    });
  //  });
  //};
  //selectUnladenWeight = (unladenWeight) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findaxles?unladenweight=" +
  //      unladenWeight +
  //      "&year=" +
  //      this.state.modelYear,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      axles: result.axles,
  //      unladenWeight: unladenWeight,
  //      axle: undefined,
  //    });
  //  });
  //};
  //selectAxle = (axle) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/finddoors?axle=" +
  //      axle +
  //      "&year=" +
  //      this.state.modelYear,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      doors: result.doors,
  //      axle: axle,
  //      door: undefined,
  //    });
  //  });
  //};
  //selectDoor = (door) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findcylinders?door)=" +
  //      door +
  //      "&year=" +
  //      this.state.modelYear,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      cylinders: result.cylinders,
  //      door: door,
  //      cylinder: undefined,
  //    });
  //  });
  //};
  //selectCylinder = (cylinder) => {
  //  fetch(
  //    process.env.REACT_APP_GLOBAL_SERVER +
  //      "mtgroup/api/evolve/findpassengers?cylinder)=" +
  //      cylinder +
  //      "&year=" +
  //      this.state.modelYear,
  //    {
  //      method: "GET",
  //      mode: "cors",
  //      headers: {
  //        "Content-Type": "application/json; charset=utf-8",
  //      },
  //    }
  //  ).then(async (res) => {
  //    if (!res.ok)
  //      Notify.error({
  //        message: "Error retrieving makes",
  //      });
  //    const result = await res.json();
  //    this.setState({
  //      passengers: result.passengers,
  //      cylinder: cylinder,
  //      passenger: undefined,
  //    });
  //  });
  //};
  //selectPassenger = (passenger) => {
  //  this.setState({
  //    passenger: passenger,
  //  });
  //};
  getDate = () => {
    var date = new Date().toDateString();
    this.setState({ date });
  };
  componentWillMount = () => {
    this.getDate();

    fetch(
      process.env.REACT_APP_GLOBAL_SERVER +
        'mtgroup/api/evolve/findstocknumbers',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving stock numbers'
        });
      const result = await res.json();
      this.setState({ stockNumbers: result.stockNumbers });
    });
    fetch(
      process.env.REACT_APP_GLOBAL_SERVER + 'mtgroup/api/evolve/findpassengers',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }
    ).then(async res => {
      if (!res.ok)
        Notify.error({
          message: 'Error retrieving stock numbers'
        });
      const result = await res.json();
      this.setState({ passengers: result.passengers });
    });
    if (this.props.editStock) {
      this.setState({
        branchImage: this.props.editStock.branchImage,
        frontLeftImage: this.props.editStock.frontLeftImage,
        frontImage: this.props.editStock.frontImage,
        frontRightImage: this.props.editStock.frontRightImage,
        rightSideImage: this.props.editStock.rightSideImage,
        wheelsImage: this.props.editStock.wheelsImage,
        backRightImage: this.props.editStock.backRightImage,
        backImage: this.props.editStock.backImage,
        backLeftImage: this.props.editStock.backLeftImage,
        leftSideImage: this.props.editStock.leftSideImage,
        bootImage: this.props.editStock.bootImage,
        frontSeatImage: this.props.editStock.frontSeatImage,
        backSeatImage: this.props.editStock.backSeatImage,
        dashPassengerImage: this.props.editStock.dashPassengerImage,
        dashDriverImage: this.props.editStock.dashDriverImage,
        dashDriverSideImage: this.props.editStock.dashDriverSideImage,
        radioImage: this.props.editStock.radioImage,
        radioCloseImage: this.props.editStock.radioCloseImage,
        gearsImage: this.props.editStock.gearsImage,
        steeringImage: this.props.editStock.steeringImage,
        spareKeyImage: this.props.editStock.spareKeyImage
      });
    }
  };
  handleBranchImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        branchImage: imageUrl
      });
    });
  };
  handleFrontLeftImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        frontLeftImage: imageUrl
      });
    });
  };
  handleFrontImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        frontImage: imageUrl
      });
    });
  };
  handleFrontRightImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        frontRightImage: imageUrl
      });
    });
  };
  handleRightSideImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        rightSideImage: imageUrl
      });
    });
  };
  handleRadioCloseImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        radioCloseImage: imageUrl
      });
    });
  };
  handleWheelsImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        wheelsImage: imageUrl
      });
    });
  };
  handleBackRightImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        backRightImage: imageUrl
      });
    });
  };
  handleBackImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        backImage: imageUrl
      });
    });
  };
  handleBackLeftImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        backLeftImage: imageUrl
      });
    });
  };
  handleLeftSideImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        leftSideImage: imageUrl
      });
    });
  };
  handleBootImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        bootImage: imageUrl
      });
    });
  };
  handleFrontSeatImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        frontSeatImage: imageUrl
      });
    });
  };
  handleBackSeatImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        backSeatImage: imageUrl
      });
    });
  };
  handleDashPassengerImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        dashPassengerImage: imageUrl
      });
    });
  };
  handleDashDriverImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        dashDriverImage: imageUrl
      });
    });
  };
  handleDashDriverSideImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        dashDriverSideImage: imageUrl
      });
    });
  };
  handleRadioImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        radioImage: imageUrl
      });
    });
  };
  handleRadioCloseImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        radioCloseImage: imageUrl
      });
    });
  };
  handleGearsImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        gearsImage: imageUrl
      });
    });
  };
  handleSteeringImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        steeringImage: imageUrl
      });
    });
  };
  handleSpareKeyImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        spareKeyImage: imageUrl
      });
    });
  };
  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };
  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 800, 800, 'PNG', 100, 0, uri => {
      callback(uri);
    });
  };

  render() {
    const {
      previewVisible,
      previewImage,
      fileList,
      previewTitle,
      date
    } = this.state;

    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    return (
      <Form layout="vertical">
        <h1
          style={{
            fontSize: '17px',
            fontWeight: 700,
            marginBottom: '-0.5em'
          }}
        >
          Vehicle Details
        </h1>
        <Row>
          <Col span={5} style={{ display: 'none' }}>
            <FormItem label={<span>Date</span>}>
              {this.props.form.getFieldDecorator('timeDate', {
                rules: [{}],
                initialValue: this.state.curDT
              })(
                <StyledInput
                  value={this.state.curDT}
                  defaultValue={this.state.curDT}
                />
              )}
            </FormItem>
          </Col>
          <Col span={1} />
        </Row>
        <Row>
          <Col
            span={5}
            style={{ position: 'fixed', bottom: '8.8em', right: '1.5em' }}
          >
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('manualInput', {
                rules: [
                  {
                    required: false
                  }
                ]
              })(
                <Tooltip placement="left" title="Manual Input">
                  <Switch
                    onChange={this.selectManual}
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                    //defaultChecked={
                    //  this.props.editStock
                    //    ? this.props.editStock.manualInput === true
                    //      ? true
                    //      : false
                    //    : false
                    //}
                  />
                </Tooltip>
              )}
            </FormItem>
          </Col>{' '}
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('webVisible', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.webVisible
                    ? true
                    : false
                  : true
              })(
                <Checkbox style={{ marginTop: '2em' }}>
                  Vehicle Visible on Website
                </Checkbox>
              )}
            </FormItem>
          </Col>{' '}
          <Col span={12}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('homeVisible', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.homeVisible
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '2em' }}>
                  Display Vehicle on Home Page
                </Checkbox>
              )}
            </FormItem>
          </Col>
        </Row>{' '}
        <Row>
          <Col span={5}>
            <FormItem label={<span>Vehicle Vin Number</span>}>
              {this.props.form.getFieldDecorator('stockNumber', {
                rules: [
                  {
                    required: false,
                    message: 'Stock Code is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.stockNumber
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect showSearch onChange={this.selectStockNumber}>
                    {this.state.stockNumbers.map(stockNumber => {
                      return (
                        <Option key={stockNumber} value={stockNumber}>
                          {stockNumber}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>{' '}
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Year</span>}>
              {this.props.form.getFieldDecorator('modelYear', {
                rules: [
                  {
                    required: true,
                    message: 'Year is required'
                  }
                ],

                initialValue: this.props.editStock
                  ? this.props.editStock.modelYear
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect showSearch onChange={this.selectYear}>
                    {this.state.years.map(modelYear => {
                      return (
                        <Option key={modelYear} value={modelYear}>
                          {modelYear}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>{' '}
        </Row>
        <Row>
          <Col span={5}>
            <FormItem label={<span>Vehicle Stock Number</span>}>
              {this.props.form.getFieldDecorator('vehicleStockNumber', {
                rules: [
                  {
                    required: false
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.vehicleStockNumber
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    //defaultValue={this.props.vehicleStockNumber}
                    showSearch
                    onChange={this.selectStockNumber}
                  >
                    {this.state.vehicleStockNumbers.map(vehicleStockNumber => {
                      return (
                        <Option
                          key={vehicleStockNumber}
                          value={vehicleStockNumber}
                        >
                          {vehicleStockNumber}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>

          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Make</span>}>
              {this.props.form.getFieldDecorator('make', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: true,
                    message: 'Make is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.make
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput
                    normalize={value => (value || '').toUpperCase()}
                  />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectMake}
                  >
                    {this.state.makes.map(make => {
                      return (
                        <Option key={make} value={make}>
                          {make}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Model</span>}>
              {this.props.form.getFieldDecorator('series', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: true,
                    message: 'Model is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.series
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectModel}
                  >
                    {this.state.models.map(series => {
                      return (
                        <Option key={series} value={series}>
                          {series}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Derivative</span>}>
              {this.props.form.getFieldDecorator('modelDesc', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: true,
                    message: 'Derivative is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.modelDesc
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectVariant}
                  >
                    {this.state.variants.map(modelDesc => {
                      return (
                        <Option key={modelDesc} value={modelDesc}>
                          {modelDesc}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Condition</span>}>
              {this.props.form.getFieldDecorator('condition', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: false,
                    message: 'Condition is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.condition
                  : ''
              })(
                <StyledSelect showSearch>
                  <Option key={'NEW'} value={'NEW'}>
                    NEW
                  </Option>
                  <Option key={'USED'} value={'USED'}>
                    USED
                  </Option>
                  <Option key={'DEMO'} value={'DEMO'}>
                    DEMO
                  </Option>
                </StyledSelect>
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Mileage</span>}>
              {this.props.form.getFieldDecorator('mileage', {
                rules: [
                  {
                    required: false,
                    message: 'Mileage is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.mileage
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput suffix="km" />
                ) : (
                  <StyledSelect
                    suffix="km"
                    showSearch
                    //onChange={this.selectMileage}
                  >
                    {this.state.mileages.map(mileage => {
                      return (
                        <Option key={mileage} value={mileage}>
                          {mileage}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Exterior Colour</span>}>
              {this.props.form.getFieldDecorator('extColour', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: false,
                    message: 'Exterior Colour is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.extColour
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect showSearch>
                    {this.state.extColours.map(extColour => {
                      return (
                        <Option key={extColour} value={extColour}>
                          {extColour}
                        </Option>
                      );
                    })}
                    {/*<Option key={"White"} value={"White"}>
                    White
                  </Option>
                  <Option key={"Black"} value={"Black"}>
                    Black
                  </Option>
                  <Option key={"Red"} value={"Red"}>
                    Red
                  </Option>
                  <Option key={"Blue"} value={"Blue"}>
                    Blue
                  </Option>
                  <Option key={"Green"} value={"Green"}>
                    Green
                  </Option>
                  <Option key={"Grey"} value={"Grey"}>
                    Grey
                  </Option>
                  <Option key={"Champagne"} value={"Champagne"}>
                    Champagne
                  </Option>
                  <Option key={"Silver"} value={"Silver"}>
                    Silver
                  </Option>
                  <Option key={"Yellow"} value={"Yellow"}>
                    Yellow
                  </Option>
                  <Option key={"Orangel"} value={"Orange"}>
                    Orange
                  </Option>
                  <Option key={"Brown"} value={"Brown"}>
                    Brown
                  </Option>
                  <Option key={"Burgundy"} value={"Burgundy"}>
                    Burgundy
                  </Option>*/}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Interior Colour</span>}>
              {this.props.form.getFieldDecorator('intColour', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: false,
                    message: 'Interior Colour is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.intColour
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect showSearch>
                    {this.state.intColours.map(intColour => {
                      return (
                        <Option key={intColour} value={intColour}>
                          {intColour}
                        </Option>
                      );
                    })}
                    {/*<Option key={"White"} value={"White"}>
                    White
                  </Option>
                  <Option key={"Black"} value={"Black"}>
                    Black
                  </Option>
                  <Option key={"Red"} value={"Red"}>
                    Red
                  </Option>
                  <Option key={"Blue"} value={"Blue"}>
                    Blue
                  </Option>
                  <Option key={"Green"} value={"Green"}>
                    Green
                  </Option>
                  <Option key={"Grey"} value={"Grey"}>
                    Grey
                  </Option>
                  <Option key={"Champagne"} value={"Champagne"}>
                    Champagne
                  </Option>
                  <Option key={"Silver"} value={"Silver"}>
                    Silver
                  </Option>
                  <Option key={"Yellow"} value={"Yellow"}>
                    Yellow
                  </Option>
                  <Option key={"Orangel"} value={"Orange"}>
                    Orange
                  </Option>
                  <Option key={"Brown"} value={"Brown"}>
                    Brown
                  </Option>
                  <Option key={"Burgundy"} value={"Burgundy"}>
                    Burgundy
                  </Option>*/}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Fuel Type</span>}>
              {this.props.form.getFieldDecorator('fuelType', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: false,
                    message: 'Fuel Type is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.fuelType
                  : ''
              })(
                <StyledSelect showSearch>
                  <Option key={'Petrol'} value={'Petrol'}>
                    {'Petrol'}
                  </Option>
                  <Option key={'Diesel'} value={'Diesel'}>
                    {'Diesel'}
                  </Option>
                  <Option key={'Hybrid'} value={'Hybrid'}>
                    {'Hybrid'}
                  </Option>
                  <Option key={'Electric'} value={'Electric'}>
                    {'Electric'}
                  </Option>
                </StyledSelect>
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Cubic Capacity</span>}>
              {this.props.form.getFieldDecorator('capacityCC', {
                rules: [
                  {
                    required: false,
                    message: 'Cubic Capacity is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.capacityCC
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectCapacityCC}
                  >
                    {this.state.capacityCCs.map(capacityCC => {
                      return (
                        <Option key={capacityCC} value={capacityCC}>
                          {capacityCC}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Body Type</span>}>
              {this.props.form.getFieldDecorator('bodyType', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: false,
                    message: 'Body Type is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.bodyType
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectBodyType}
                  >
                    <Option key={'Cabriolet'} value={'Cabriolet'}>
                      Cabriolet
                    </Option>
                    <Option key={'Coupe'} value={'Coupe'}>
                      Coupe
                    </Option>
                    <Option key={'Crossover'} value={'Crossover'}>
                      Crossover
                    </Option>
                    <Option key={'DoubleCab'} value={'Double Cab'}>
                      Double Cab
                    </Option>
                    <Option key={'SingleCab'} value={'Single Cab'}>
                      Single Cab
                    </Option>
                    <Option key={'SuperCab'} value={'Super Cab'}>
                      Super Cab
                    </Option>
                    <Option key={'Hatchback'} value={'Hatchback'}>
                      Hatchback
                    </Option>
                    <Option key={'Minibus'} value={'Minibus'}>
                      Minibus
                    </Option>
                    <Option key={'MPV'} value={'MPV'}>
                      MPV
                    </Option>
                    <Option key={'PanelVan'} value={'Panel Van'}>
                      Panel Van
                    </Option>
                    <Option key={'SUV'} value={'SUV'}>
                      SUV
                    </Option>
                    <Option key={'Sedan'} value={'Sedan'}>
                      Sedan
                    </Option>
                    {/*{this.state.bodyTypes.map((bodyType) => {
                      return (
                        <Option key={bodyType} value={bodyType}>
                          {bodyType}
                        </Option>
                      );
                    })}*/}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Transmission</span>}>
              {this.props.form.getFieldDecorator('transmission', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: false,
                    message: 'Transmission is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.transmission
                  : ''
              })(
                <StyledSelect showSearch>
                  <Option key={'Automatic'} value={'Automatic'}>
                    Automatic
                  </Option>
                  <Option key={'Manual'} value={'Manual'}>
                    Manual
                  </Option>
                  <Option key={'Semi'} value={'Semi Auto'}>
                    Semi Auto
                  </Option>
                </StyledSelect>
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          {/*<Col span={5}>
            <FormItem label={<span>Engine Size</span>}>
              {this.props.form.getFieldDecorator("engineSize", {
                rules: [
                  {
                    required: false,
                    message: "EngineSize is required",
                  },
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.engineSize
                  : "",
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect showSearch onChange={this.selectEngineSize}>
                    {this.state.engineSizes.map((engineSize) => {
                      return (
                        <Option key={engineSize} value={engineSize}>
                          {engineSize}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />*/}
          <Col span={5}>
            <FormItem label={<span>Vehicle Drive</span>}>
              {this.props.form.getFieldDecorator('vehicleDrive', {
                normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: false,
                    message: 'Vehicle Drive is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.vehicleDrive
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectVehicleDrive}
                  >
                    {this.state.vehicleDrives.map(vehicleDrive => {
                      return (
                        <Option key={vehicleDrive} value={vehicleDrive}>
                          {vehicleDrive}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Unladen Weight</span>}>
              {this.props.form.getFieldDecorator('unladenWeight', {
                rules: [
                  {
                    required: false,
                    message: 'Unladen Weight is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.unladenWeight
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectUnladenWeight}
                  >
                    {this.state.unladenWeights.map(unladenWeight => {
                      return (
                        <Option key={unladenWeight} value={unladenWeight}>
                          {unladenWeight}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Axle</span>}>
              {this.props.form.getFieldDecorator('axle', {
                rules: [
                  {
                    required: false,
                    message: 'axle is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.axle
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectAxle}
                  >
                    {this.state.axles.map(axle => {
                      return (
                        <Option key={axle} value={axle}>
                          {axle}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Door</span>}>
              {this.props.form.getFieldDecorator('door', {
                rules: [
                  {
                    required: false,
                    message: 'door is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.door
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectDoor}
                  >
                    {this.state.doors.map(door => {
                      return (
                        <Option key={door} value={door}>
                          {door}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Cylinder</span>}>
              {this.props.form.getFieldDecorator('cylinder', {
                rules: [
                  {
                    required: false,
                    message: 'cylinder is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.cylinder
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectCylinder}
                  >
                    {this.state.cylinders.map(cylinder => {
                      return (
                        <Option key={cylinder} value={cylinder}>
                          {cylinder}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Passenger</span>}>
              {this.props.form.getFieldDecorator('passenger', {
                rules: [
                  {
                    required: false,
                    message: 'passenger is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.passenger
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect
                    showSearch
                    //onChange={this.selectPassenger}
                  >
                    {this.state.passengers.map(passenger => {
                      return (
                        <Option key={passenger} value={passenger}>
                          {passenger}
                        </Option>
                      );
                    })}
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          {/*<Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Intro Date</span>}>
              {this.props.form.getFieldDecorator("introDate", {
                rules: [{ required: false, message: "Intro Date is required" }],
                initialValue: this.props.editStock
                  ? this.props.editStock.introDate
                  : "",
              })(
                <StyledSelect showSearch>
                  <Option key={"introDate"} value={"Intro Date"}>
                    Intro Date (EVOLVE)
                  </Option>
                </StyledSelect>
              )}
            </FormItem>
          </Col>*/}
        </Row>
        <Row>
          <Col span={5}>
            <FormItem label={<span>Retail Price Incl.</span>}>
              {this.props.form.getFieldDecorator('retailPriceIncl', {
                rules: [
                  { required: false, message: 'Retail Price is required' }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.retailPriceIncl
                  : ''
              })(
                <h1>
                  {this.state.retailIncs.map(retailPriceIncl => {
                    return (
                      <InputNumber
                        disabled
                        defaultValue={retailPriceIncl}
                        style={{ width: '100%' }}
                        formatter={value =>
                          `R ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                        parser={value => value.replace(/\R\s?|(,*)/g, '')}
                      />
                    );
                  })}
                </h1>
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Price</span>}>
              {this.props.form.getFieldDecorator('price', {
                rules: [{ required: true, message: 'Price is required' }],
                initialValue: this.props.editStock
                  ? this.props.editStock.price
                  : ''
              })(
                <InputNumber
                  style={{ width: '100%' }}
                  formatter={value =>
                    `R ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  parser={value => value.replace(/\R\s?|(,*)/g, '')}
                />
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('onSale', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.onSale
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '2em' }}>On Sale</Checkbox>)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={23}>
            <FormItem label={<span>Comments</span>}>
              {this.props.form.getFieldDecorator('comments', {
                rules: [
                  {
                    required: false,
                    message: 'Comments is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.comments
                  : ''
              })(<StyledInput />)}
            </FormItem>
          </Col>
        </Row>{' '}
        <Row>
          <Col span={23}>
            <FormItem label={<span>Vehicle Extras And Accessories</span>}>
              {this.props.form.getFieldDecorator('extras', {
                rules: [
                  {
                    required: false,
                    message: 'Extras is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.extras
                  : ''
              })(<StyledInput />)}
            </FormItem>
          </Col>
        </Row>{' '}
        <h1
          style={{
            marginBottom: '1.5em',
            marginTop: '1.5em',
            fontSize: '17px',
            fontWeight: 700
          }}
        >
          Extras And Accessories
        </h1>
        <Row>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('degreeCamera', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.degreeCamera
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  360 Degree Camera
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('fourWheelDrive', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.fourWheelDrive
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>4WD</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('abs', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.abs
                  : ''
              })(<Checkbox style={{ marginTop: '0em' }}>ABS</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('driverAssistance', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.driverAssistance
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Advanced Driver Assistance System
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('airBags', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.airBags
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>Airbags</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('aircon', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.aircon
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>Aircon</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('alarm', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.alarm
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>Alarm</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('mobileCarPlay', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.mobileCarPlay
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Apple CarPlay / Android Auto
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('automaticLights', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.automaticLights
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Automatic Lights
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('automaticWipers', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.automaticWipers
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Automatic Wipers
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('autonomousBraking', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.autonomousBraking
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Autonomous Emergency Braking
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('blindSpotMonitoring', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.blindSpotMonitoring
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Blind Spot Monitoring
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('bluetooth', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.bluetooth
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>Bluetooth</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('brakeAssist', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.brakeAssist
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>Brake Assist</Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('climateControl', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.climateControl
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Climate Control
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('cruiseControl', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.cruiseControl
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>Cruise Control</Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('daytimeLights', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.daytimeLights
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Daytime Running Lights
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('electricParkingBrake', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.electricParkingBrake
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Electric Parking Brake
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('elctricWindows', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.elctricWindows
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Electric Windows
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('electronicStability', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.electronicStability
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Electronic Stability System
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('collisionWarning', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.collisionWarning
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Forward Collision Warning
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('headDisplay', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.headDisplay
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Head-up Display
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('heatedSeats', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.heatedSeats
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Heated / Ventilated Seats
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('hillAssist', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.hillAssist
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>Hill Assist</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('hillControl', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.hillControl
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Hill Descent Control
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('keylessEntry', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.keylessEntry
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>Keyless Entry</Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('laneWarning', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.laneWarning
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Lane Departure Warning
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('laneAssist', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.laneAssist
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Lane Keeping Assist
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('leatherSeats', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.leatherSeats
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>Leather Seats</Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('ledLights', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.ledLights
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>LED Lights</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('navigation', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.navigation
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>Navigation</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('paddleShift', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.paddleShift
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>Paddle Shift</Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('parkControl', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.parkControl
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Park Distance Control
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('powerBoot', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.powerBoot
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>Power Boot</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('powerSeat', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.powerSeat
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>Power Seat(s)</Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('remoteStart', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.remoteStart
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>Remote Start</Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('reverseCamera', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.reverseCamera
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>Reverse Camera</Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('sunroof', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.sunroof
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>Sunroof</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('touchScreen', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.touchScreen
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Touch Screen Infotainment System
                </Checkbox>
              )}
            </FormItem>
          </Col>{' '}
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('towbar', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.towbar
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>Towbar</Checkbox>)}
            </FormItem>
          </Col>{' '}
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('signRecognition', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.signRecognition
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Traffic Sign Recognition
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('tyreMonitor', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.tyreMonitor
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Tyre Pressure Monitor System
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('usbPort', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.usbPort
                    ? true
                    : false
                  : false
              })(<Checkbox style={{ marginTop: '0em' }}>USB Port(s)</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('voiceRecognition', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.voiceRecognition
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Voice Recognition
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('warranty', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.warranty
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Warranty / Service Plan
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('wirelessCharging', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.wirelessCharging
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>
                  Wireless Charging
                </Checkbox>
              )}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="  ">
              {this.props.form.getFieldDecorator('xenonLights', {
                rules: [
                  {
                    required: false
                  }
                ],
                valuePropName: 'checked',
                initialValue: this.props.editStock
                  ? this.props.editStock.xenonLights
                    ? true
                    : false
                  : false
              })(
                <Checkbox style={{ marginTop: '0em' }}>Xenon Lights</Checkbox>
              )}
            </FormItem>
          </Col>
        </Row>
        <h1
          style={{
            marginTop: '1.5em',
            marginBottom: '1.5em',
            fontSize: '17px',
            fontWeight: 700
          }}
        >
          Branch Details
        </h1>
        <Row>
          <Col span={5}>
            <FormItem label={<span>Branch</span>}>
              {this.props.form.getFieldDecorator('branch', {
                rules: [
                  {
                    required: true,
                    message: 'Branch is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.branch
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect showSearch>
                    <Option value="Klerksdorp">Klerksdorp</Option>
                    <Option value="Potchefstroom">Potchefstroom</Option>
                    <Option value="Mahikeng">Mahikeng</Option>
                    <Option value="Lichtenburg">Lichtenburg</Option>
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Brand</span>}>
              {this.props.form.getFieldDecorator('brand', {
                rules: [{ required: true, message: 'Brand is required' }],
                initialValue: this.props.editStock
                  ? this.props.editStock.brand
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect showSearch>
                    <Option value="Mega Theron Group">Mega Theron Group</Option>
                    <Option value="Mega Theron Traders">
                      Mega Theron Traders
                    </Option>
                    <Option value="Kia">Kia</Option>
                    <Option value="Mahindra">Mahindra</Option>
                    <Option value="Chery">Chery</Option>
                    <Option value="Gwm">GWM</Option>
                    <Option value="Haval">Haval</Option>
                    <Option value="JAC">JAC</Option>
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>

          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Lead Email</span>}>
              {this.props.form.getFieldDecorator('email', {
                rules: [
                  {
                    required: true,
                    message: 'Lead Email is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.email
                  : ''
              })(
                <StyledInput />
                // this.state.manualInput === true ? (
                //   <StyledInput />
                // ) : (
                //   <StyledSelect showSearch>
                //     <Option key={'Allan'} value={'allan@megatheron.co.za'}>
                //       allan@megatheron.co.za
                //     </Option>
                //     <Option key={'Xander'} value={'xander@megatheron.co.za'}>
                //       xander@megatheron.co.za
                //     </Option>
                //     <Option key={'Mega Theron'} value={'info@megatheron.co.za'}>
                //       info@megatheron.co.za
                //     </Option>
                //   </StyledSelect>
                // )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
          <Col span={5}>
            <FormItem label={<span>Branch Number</span>}>
              {this.props.form.getFieldDecorator('number', {
                rules: [
                  {
                    required: false,
                    message: 'Branch Number is required'
                  }
                ],
                initialValue: this.props.editStock
                  ? this.props.editStock.number
                  : ''
              })(
                this.state.manualInput === true ? (
                  <StyledInput />
                ) : (
                  <StyledSelect showSearch>
                    <Option key={'Megatheron'} value={'018 001 0218'}>
                      018 001 0218
                    </Option>
                  </StyledSelect>
                )
              )}
            </FormItem>
          </Col>
          <Col span={1} />
        </Row>
        <h1
          style={{
            marginTop: '1.5em',
            marginBottom: '1.5em',
            fontSize: '17px',
            fontWeight: 700
          }}
        >
          Branch Image (Optional)
        </h1>
        <Row type="flex" justify="space-between" align="middle">
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 10
              }}
              extra={
                this.state.branchImage ? (
                  <div onClick={e => this.setState({ branchImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>Branch Image</span>
              }
              cover={
                this.state.branchImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.branchImage.search('data') > -1
                        ? this.state.branchImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.branchImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="branchImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleBranchImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <ButtonSquare>Upload Image</ButtonSquare>
                </Upload>
              ]}
            />
          </Col>
        </Row>
        <h1
          style={{
            marginTop: '1.5em',
            marginBottom: '1.5em',
            fontSize: '17px',
            fontWeight: 700
          }}
        >
          Image Uploads
        </h1>
        <Row type="flex" justify="space-between" align="middle">
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 10
              }}
              extra={
                this.state.frontLeftImage ? (
                  <div onClick={e => this.setState({ frontLeftImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Front Left View
                </span>
              }
              cover={
                this.state.frontLeftImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.frontLeftImage.search('data') > -1
                        ? this.state.frontLeftImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.frontLeftImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="frontLeftImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleFrontLeftImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <ButtonSquare>Upload Image</ButtonSquare>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.frontImage ? (
                  <div onClick={e => this.setState({ frontImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>Front View</span>
              }
              cover={
                this.state.frontImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.frontImage.search('data') > -1
                        ? this.state.frontImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.frontImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="frontImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleFrontImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.frontRightImage ? (
                  <div onClick={e => this.setState({ frontRightImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  {' '}
                  Front Right View
                </span>
              }
              cover={
                this.state.frontRightImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.frontRightImage.search('data') > -1
                        ? this.state.frontRightImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.frontRightImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="frontRightImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleFrontRightImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.rightSideImage ? (
                  <div onClick={e => this.setState({ rightSideImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Right Side View
                </span>
              }
              cover={
                this.state.rightSideImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.rightSideImage.search('data') > -1
                        ? this.state.rightSideImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.rightSideImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="rightSideImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleRightSideImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>{' '}
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.wheelsImage ? (
                  <div onClick={e => this.setState({ wheelsImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>Wheels View</span>
              }
              cover={
                this.state.wheelsImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.wheelsImage.search('data') > -1
                        ? this.state.wheelsImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.wheelsImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="wheelsImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleWheelsImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>{' '}
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.backRightImage ? (
                  <div onClick={e => this.setState({ backRightImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Back Corner View
                </span>
              }
              cover={
                this.state.backRightImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.backRightImage.search('data') > -1
                        ? this.state.backRightImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.backRightImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="backRightImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleBackRightImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.backImage ? (
                  <div onClick={e => this.setState({ backImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>Back View</span>
              }
              cover={
                this.state.backImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.backImage.search('data') > -1
                        ? this.state.backImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.backImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="backImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleBackImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.backLeftImage ? (
                  <div onClick={e => this.setState({ backLeftImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Back Corner View
                </span>
              }
              cover={
                this.state.backLeftImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.backLeftImage.search('data') > -1
                        ? this.state.backLeftImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.backLeftImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="backLeftImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleBackLeftImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.leftSideImage ? (
                  <div onClick={e => this.setState({ leftSideImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>Left Side View</span>
              }
              cover={
                this.state.leftSideImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.leftSideImage.search('data') > -1
                        ? this.state.leftSideImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.leftSideImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="leftSideImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleLeftSideImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.bootImage ? (
                  <div onClick={e => this.setState({ bootImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Boot (Interior)
                </span>
              }
              cover={
                this.state.bootImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.bootImage.search('data') > -1
                        ? this.state.bootImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.bootImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="bootImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleBootImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.frontSeatImage ? (
                  <div onClick={e => this.setState({ frontSeatImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Front Seats View
                </span>
              }
              cover={
                this.state.frontSeatImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.frontSeatImage.search('data') > -1
                        ? this.state.frontSeatImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.frontSeatImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="frontSeatImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleFrontSeatImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.backSeatImage ? (
                  <div onClick={e => this.setState({ backSeatImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Back Seats View
                </span>
              }
              cover={
                this.state.backSeatImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.backSeatImage.search('data') > -1
                        ? this.state.backSeatImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.backSeatImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="backSeatImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleBackSeatImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.dashPassengerImage ? (
                  <div
                    onClick={e => this.setState({ dashPassengerImage: null })}
                  >
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  passenger Dash View
                </span>
              }
              cover={
                this.state.dashPassengerImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.dashPassengerImage.search('data') > -1
                        ? this.state.dashPassengerImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.dashPassengerImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="dashPassengerImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleDashPassengerImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.dashDriverImage ? (
                  <div onClick={e => this.setState({ dashDriverImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Driver Dash View
                </span>
              }
              cover={
                this.state.dashDriverImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.dashDriverImage.search('data') > -1
                        ? this.state.dashDriverImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.dashDriverImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="dashDriverImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleDashDriverImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.dashDriverSideImage ? (
                  <div
                    onClick={e => this.setState({ dashDriverSideImage: null })}
                  >
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Dash – Driver View
                </span>
              }
              cover={
                this.state.dashDriverSideImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.dashDriverSideImage.search('data') > -1
                        ? this.state.dashDriverSideImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.dashDriverSideImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="dashDriverSideImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleDashDriverSideImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.radioImage ? (
                  <div onClick={e => this.setState({ radioImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>Radio View</span>
              }
              cover={
                this.state.radioImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.radioImage.search('data') > -1
                        ? this.state.radioImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.radioImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="radioImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleRadioImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.radioCloseImage ? (
                  <div onClick={e => this.setState({ radioCloseImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Radio Close Up View
                </span>
              }
              cover={
                this.state.radioCloseImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.radioCloseImage.search('data') > -1
                        ? this.state.radioCloseImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.radioCloseImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="radioCloseImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleRadioCloseImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.gearsImage ? (
                  <div onClick={e => this.setState({ gearsImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Gears/Auto View
                </span>
              }
              cover={
                this.state.gearsImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.gearsImage.search('data') > -1
                        ? this.state.gearsImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.gearsImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="gearsImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleGearsImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.steeringImage ? (
                  <div onClick={e => this.setState({ steeringImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>Steering Wheel</span>
              }
              cover={
                this.state.steeringImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.steeringImage.search('data') > -1
                        ? this.state.steeringImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.steeringImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="steeringImage"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleSteeringImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
          <Col span={6} style={{ padding: '0.5em' }}>
            <Cards
              style={{
                width: '100%',
                border: '1px solid rgb(249, 23, 0)',
                marginBottom: 15
              }}
              extra={
                this.state.spareKeyImage ? (
                  <div onClick={e => this.setState({ spareKeyImage: null })}>
                    <CloseCircleFilled style={{ color: 'red' }} />
                    <span style={{ color: 'red' }}>Remove</span>
                  </div>
                ) : (
                  ''
                )
              }
              title={
                <span style={{ color: 'rgb(249, 23, 0)' }}>
                  Service book & Spare key (used floors)
                </span>
              }
              cover={
                this.state.spareKeyImage ? (
                  <img
                    alt="example"
                    src={
                      this.state.spareKeyImage.search('data') > -1
                        ? this.state.spareKeyImage
                        : process.env.REACT_APP_GLOBAL_SERVER +
                          'mtgroup/api/images/' +
                          this.state.spareKeyImage
                    }
                  />
                ) : (
                  <img alt="example" src={dropImage} />
                )
              }
              actions={[
                <Upload
                  name="spareKeyImage "
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  customRequest={this.handleImageUpload}
                  onChange={this.handleSpareKeyImage}
                  loading={this.state.loading}
                  accept="image/*"
                >
                  <Button>Upload Image</Button>
                </Upload>
              ]}
            />
          </Col>
        </Row>
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>{' '}
        {/*<Row type='flex' justify='space-around' align='middle'>
          <Button type='primary' onClick={this.props.onOk}>
            {this.props.okText}
          </Button>
          <Button type='primary' onClick={this.props.onCancel}>
            Cancel
          </Button>
        </Row>*/}
      </Form>
    );
  }
}
const StockForm = Form.create()(AddStockForm);

class Stock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      closed: false,
      rejectReason: '',
      editStock: undefined,
      size: 'large',
      flag: false,
      currentTab: 'All'
    };
  }
  updateSignal;
  componentWillMount = () => {
    this.setState({ loading: true });
    this.props
      .findAllStock()
      .then(() => {
        let itemCodes = [];
        this.props.stock.forEach(stock => {
          if (stock.itemCode) {
            itemCodes.push(
              'Part: ' + stock.itemCode + ' - Location: ' + stock.location
            );
          }
        });
        this.setState({ loading: false, itemCodes: itemCodes });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
    this.updateSignal = {
      signal: msg => {
        this.props
          .findAllStock()
          .then(() => {
            let itemCodes = [];
            this.props.stock.forEach(stock => {
              if (stock.itemCode) {
                itemCodes.push(
                  'Part: ' + stock.itemCode + ' - Location: ' + stock.location
                );
              }
            });
            this.setState({ loading: false, itemCodes: itemCodes });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    };
    window.pubnub.addListener(this.updateSignal);
    window.addEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.addEventListener('backbutton', this.handleBack);
    }
  };
  handleBack = () => {
    if (this.state.previewVisible) {
      this.setState({ previewVisible: false });
    } else {
      this.props.history.goBack();
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  vehiclesForm;
  onAddStock = e => {
    this.setState({ previewVisible: true, editStock: undefined });
  };

  handleAddStock = e => {
    e.preventDefault();
    this.vehiclesForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        values.branchImage = this.vehiclesForm.state.branchImage;
        values.frontLeftImage = this.vehiclesForm.state.frontLeftImage;
        values.frontImage = this.vehiclesForm.state.frontImage;
        values.frontRightImage = this.vehiclesForm.state.frontRightImage;
        values.rightSideImage = this.vehiclesForm.state.rightSideImage;
        values.wheelsImage = this.vehiclesForm.state.wheelsImage;
        values.backRightImage = this.vehiclesForm.state.backRightImage;
        values.backImage = this.vehiclesForm.state.backImage;
        values.backLeftImage = this.vehiclesForm.state.backLeftImage;
        values.leftSideImage = this.vehiclesForm.state.leftSideImage;
        values.bootImage = this.vehiclesForm.state.bootImage;
        values.frontSeatImage = this.vehiclesForm.state.frontSeatImage;
        values.backSeatImage = this.vehiclesForm.state.backSeatImage;
        values.dashPassengerImage = this.vehiclesForm.state.dashPassengerImage;
        values.dashDriverImage = this.vehiclesForm.state.dashDriverImage;
        values.dashDriverSideImage = this.vehiclesForm.state.dashDriverSideImage;
        values.radioImage = this.vehiclesForm.state.radioImage;
        values.radioCloseImage = this.vehiclesForm.state.radioCloseImage;
        values.gearsImage = this.vehiclesForm.state.gearsImage;
        values.steeringImage = this.vehiclesForm.state.steeringImage;
        values.spareKeyImage = this.vehiclesForm.state.spareKeyImage;
        if (this.state.editStock) {
          values._id = this.state.editStock._id;
        }
        this.props
          .addStock(values)
          .then(() => {
            this.props
              .findAllStock()
              .then(() => {
                if (this.state.editStock) {
                  Notify('success', 'Successfully saved vehicle');
                } else {
                  Notify('success', 'Successfully added vehicle');
                }
                this.vehiclesForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  previewVisible: false,
                  editStock: undefined,
                  currentTab: 'All'
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })

          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };

  handleEditStock = e => {
    this.setState({ previewVisible: true, editStock: e });
  };

  handleDeleteStock = e => {
    const id = e.currentTarget.getAttribute('data');
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are you sure you want to delete this vehicle?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteStock(id)
          .then(() => {
            that.props
              .findAllStock()
              .then(() => {
                that.setState({ loading: false, currentTab: 'All' });
                // that.props.find140mm();
                // that.props.find171mm();
                Notify('success', 'Successfully deleted vehicle');
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify('error', e);
          });
      },
      oncancel() {}
    });
  };
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', pagination, sorter);
    this.setState({
      sortedInfo: sorter
    });
  };
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });

  renderCondition = (condition, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {condition}
      </p>
    );
  };

  changeTypeTab = key => {
    this.setState({ currentTab: key });
  };

  render() {
    let descriptions = this.props.stock.map(vehicle => {
      return { value: vehicle.description };
    });
    const { condition } = this.state;
    const { stock } = this.props;
    let vehicles;
    if (this.state.currentTab === 'All') {
      vehicles = stock;
    } else {
      vehicles = stock.filter(
        vehicle => vehicle.condition === this.state.currentTab
      );
    }
    const dataSource = [
      {
        key: '1',
        name: 'Mike',
        age: 32,
        address: '10 Downing Street'
      },
      {
        key: '2',
        name: 'John',
        age: 42,
        address: '10 Downing Street'
      }
    ];

    const columns = [
      {
        title: 'Year',
        dataIndex: 'modelYear',
        key: 'modelYear'
      },
      {
        title: 'Make',
        dataIndex: 'make',
        key: 'make'
      },
      {
        title: 'Model',
        dataIndex: 'series',
        key: 'series'
      },
      {
        title: 'Derivative',
        dataIndex: 'modelDesc',
        key: 'modelDesc'
      },
      {
        title: 'Condition',
        dataIndex: 'condition',
        //key: "condition",
        render: condition => {
          switch (condition) {
            case 'NEW':
              return this.renderCondition('NEW', '#4BED5B');
            case 'USED':
              return this.renderCondition('USED', '#EE4C4C');
            case 'DEMO':
              return this.renderCondition('DEMO', '#FF8F28');
            default:
              return this.renderCondition('None', 'lightgrey');
          }
        }
      },
      {
        title: 'Price',
        dataIndex: 'price',
        //key: "price",
        render: price => (
          <StyledInputNumber
            bordered={false}
            defaultValue={price}
            disabled
            formatter={price =>
              `R ${price}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={price => price.replace(/\R\s?|(,*)/g, '')}
          />
        )
      },
      {
        title: 'Date',
        dataIndex: 'timeDate',
        key: 'timeDate'
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        render: (text, stock) => (
          <span>
            <Button
              style={{
                backgroundColor: '#F91700',
                color: 'white',
                borderRadius: '3em'
              }}
              onClick={e => this.handleEditStock(stock)}
            >
              Edit
            </Button>
            <Divider type="vertical" />
            <DeleteFilled
              style={{
                backgroundColor: '#CFD5E3',
                color: 'white',
                padding: '0.5em',
                borderRadius: '3em'
              }}
              data={stock._id}
              onClick={this.handleDeleteStock}
            />
          </span>
        )
      }
    ];
    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        <Spin spinning={this.state.loading}>
          {this.state.previewVisible ? (
            <Card
              bordered={false}
              extra={
                <Title
                  style={{
                    paddingRight: '75em',
                    fontSize: '20px',
                    fontWeight: 700,
                    whiteSpace: 'nowrap'
                  }}
                >
                  {this.state.editStock ? 'Edit Stock' : 'Add Stock'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: '15px',
                      whiteSpace: 'nowrap',
                      marginTop: '0.5em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editStock
                      ? 'Please click save to edit vehicle'
                      : 'Fill in all fields and click save to add a new vehicle'}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: '3em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  padding: '3em',
                  paddingTop: '1em',
                  paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <StockForm
                  descriptions={descriptions}
                  editStock={this.state.editStock}
                  wrappedComponentRef={form => (this.vehiclesForm = form)}
                />
                <Tooltip placement="left" title="Save Vehicle">
                  <Button
                    type="primary"
                    shape="round"
                    onClick={this.handleAddStock}
                    size="large"
                    style={{
                      position: 'fixed',
                      bottom: '6.5em',
                      right: '1em',
                      fontSize: '14px',
                      width: '4em',
                      height: '4em',
                      //height: "3em",
                      marginLeft: '0.7em'
                    }}
                  >
                    <CheckOutlined />
                  </Button>
                </Tooltip>
                <Tooltip placement="left" title="Cancel">
                  <Button
                    shape="round"
                    onClick={e => this.setState({ previewVisible: false })}
                    style={{
                      fontSize: '14px',
                      width: '4em',
                      height: '4em',
                      position: 'fixed',
                      bottom: '2em',
                      right: '1em',
                      border: '1px solid #EEEFF0',
                      backgroundColor: 'lightgrey'
                    }}
                  >
                    <CloseOutlined />
                  </Button>
                </Tooltip>
              </div>
            </Card>
          ) : (
            <Row>
              <Col span={24}>
                <StyledTabs
                  style={{ marginTop: '1em' }}
                  defaultActiveKey="1"
                  onChange={this.changeTypeTab}
                  tabBarExtraContent={{
                    left: (
                      <Button
                        type="primary"
                        shape="round"
                        onClick={this.onAddStock}
                        icon={
                          <PlusCircleOutlined style={{ fontSize: '110%' }} />
                        }
                        size="large"
                        style={{
                          marginRight: '2.5em',
                          height: '3em',
                          width: '9em'
                        }}
                      >
                        Add Stock
                      </Button>
                    ),

                    right: (
                      <h1 style={{ color: '#656565', fontSize: 22 }}>
                        Total Stock:
                        <span
                          style={{ color: 'rgb(249, 23, 0)', fontSize: 25 }}
                        >
                          {this.props.stock.length}
                        </span>
                      </h1>
                    )
                  }}
                >
                  <TabPane tab="All" key="All">
                    <StyledTable
                      bordered={false}
                      dataSource={vehicles}
                      rowKey="_id"
                      size="middle"
                      pagination={{
                        defaultPageSize: 25
                      }}
                      style={{
                        minWidth: '15em',
                        marginTop: '0.5em'
                      }}
                    >
                      <Column
                        {...this.getColumnSearchProps('vehicleStockNumber')}
                        title="Stock Number"
                        dataIndex="vehicleStockNumber"
                        key="vehicleStockNumber"
                      />
                      <Column
                        {...this.getColumnSearchProps('modelYear')}
                        title="Year"
                        dataIndex="modelYear"
                        key="modelYear"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('make')}
                        title="Make"
                        dataIndex="make"
                        key="make"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('series')}
                        title="Model"
                        dataIndex="series"
                        key="series"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('modelDesc')}
                        title="Derivative"
                        dataIndex="modelDesc"
                        key="modelDesc"
                      />
                      <Column
                        {...this.getColumnSearchProps('condition')}
                        title="Condition"
                        dataIndex="condition"
                        //key: "condition",
                        render={condition => {
                          switch (condition) {
                            case 'NEW':
                              return this.renderCondition('NEW', '#4BED5B');
                            case 'USED':
                              return this.renderCondition('USED', '#EE4C4C');
                            case 'DEMO':
                              return this.renderCondition('DEMO', '#FF8F28');
                            default:
                              return this.renderCondition('None', 'lightgrey');
                          }
                        }}
                      />
                      <Column
                        {...this.getColumnSearchProps('timeDate')}
                        title="Date"
                        dataIndex="timeDate"
                        key="timeDate"
                      />
                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        render={(text, stock) => (
                          <span>
                            <Button
                              style={{
                                backgroundColor: '#F91700',
                                color: 'white',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditStock(stock)}
                            >
                              Edit
                            </Button>
                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: '#CFD5E3',
                                color: 'white',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              data={stock._id}
                              onClick={this.handleDeleteStock}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane>
                  <TabPane tab="NEW" key="NEW">
                    <StyledTable
                      bordered={false}
                      dataSource={vehicles}
                      //columns={columns}
                      rowKey="_id"
                      size="middle"
                      pagination={{
                        defaultPageSize: 25
                      }}
                      style={{
                        minWidth: '15em',
                        marginTop: '0.5em'
                      }}
                    >
                      <Column
                        {...this.getColumnSearchProps('vehicleStockNumber')}
                        title="Stock Number"
                        dataIndex="vehicleStockNumber"
                        key="vehicleStockNumber"
                      />
                      <Column
                        {...this.getColumnSearchProps('modelYear')}
                        title="Year"
                        dataIndex="modelYear"
                        key="modelYear"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('make')}
                        title="Make"
                        dataIndex="make"
                        key="make"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('series')}
                        title="Model"
                        dataIndex="series"
                        key="series"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('modelDesc')}
                        title="Derivative"
                        dataIndex="modelDesc"
                        key="modelDesc"
                      />
                      <Column
                        {...this.getColumnSearchProps('condition')}
                        title="Condition"
                        dataIndex="condition"
                        //key: "condition",
                        render={condition => {
                          switch (condition) {
                            case 'NEW':
                              return this.renderCondition('NEW', '#4BED5B');
                            case 'USED':
                              return this.renderCondition('USED', '#EE4C4C');
                            case 'DEMO':
                              return this.renderCondition('DEMO', '#FF8F28');
                            default:
                              return this.renderCondition('None', 'lightgrey');
                          }
                        }}
                      />
                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        render={(text, stock) => (
                          <span>
                            <Button
                              style={{
                                backgroundColor: '#F91700',
                                color: 'white',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditStock(stock)}
                            >
                              Edit
                            </Button>
                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: '#CFD5E3',
                                color: 'white',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              data={stock._id}
                              onClick={this.handleDeleteStock}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane>
                  <TabPane tab="USED" key="USED">
                    <StyledTable
                      bordered={false}
                      dataSource={vehicles}
                      //columns={columns}
                      rowKey="_id"
                      size="middle"
                      pagination={{
                        defaultPageSize: 25
                      }}
                      style={{
                        minWidth: '15em',
                        marginTop: '0.5em'
                      }}
                    >
                      <Column
                        {...this.getColumnSearchProps('vehicleStockNumber')}
                        title="Stock Number"
                        dataIndex="vehicleStockNumber"
                        key="vehicleStockNumber"
                      />
                      <Column
                        {...this.getColumnSearchProps('modelYear')}
                        title="Year"
                        dataIndex="modelYear"
                        key="modelYear"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('make')}
                        title="Make"
                        dataIndex="make"
                        key="make"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('series')}
                        title="Model"
                        dataIndex="series"
                        key="series"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('modelDesc')}
                        title="Derivative"
                        dataIndex="modelDesc"
                        key="modelDesc"
                      />
                      <Column
                        {...this.getColumnSearchProps('condition')}
                        title="Condition"
                        dataIndex="condition"
                        //key: "condition",
                        render={condition => {
                          switch (condition) {
                            case 'NEW':
                              return this.renderCondition('NEW', '#4BED5B');
                            case 'USED':
                              return this.renderCondition('USED', '#EE4C4C');
                            case 'DEMO':
                              return this.renderCondition('DEMO', '#FF8F28');
                            default:
                              return this.renderCondition('None', 'lightgrey');
                          }
                        }}
                      />
                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        render={(text, stock) => (
                          <span>
                            <Button
                              style={{
                                backgroundColor: '#F91700',
                                color: 'white',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditStock(stock)}
                            >
                              Edit
                            </Button>
                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: '#CFD5E3',
                                color: 'white',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              data={stock._id}
                              onClick={this.handleDeleteStock}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane>
                  <TabPane tab="DEMO" key="DEMO">
                    <StyledTable
                      bordered={false}
                      dataSource={vehicles}
                      //columns={columns}
                      rowKey="_id"
                      size="middle"
                      pagination={{
                        defaultPageSize: 25
                      }}
                      style={{
                        minWidth: '15em',
                        marginTop: '0.5em'
                      }}
                    >
                      <Column
                        {...this.getColumnSearchProps('vehicleStockNumber')}
                        title="Stock Number"
                        dataIndex="vehicleStockNumber"
                        key="vehicleStockNumber"
                      />
                      <Column
                        {...this.getColumnSearchProps('modelYear')}
                        title="Year"
                        dataIndex="modelYear"
                        key="modelYear"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('make')}
                        title="Make"
                        dataIndex="make"
                        key="make"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('series')}
                        title="Model"
                        dataIndex="series"
                        key="series"
                      />{' '}
                      <Column
                        {...this.getColumnSearchProps('modelDesc')}
                        title="Derivative"
                        dataIndex="modelDesc"
                        key="modelDesc"
                      />
                      <Column
                        {...this.getColumnSearchProps('condition')}
                        title="Condition"
                        dataIndex="condition"
                        //key: "condition",
                        render={condition => {
                          switch (condition) {
                            case 'NEW':
                              return this.renderCondition('NEW', '#4BED5B');
                            case 'USED':
                              return this.renderCondition('USED', '#EE4C4C');
                            case 'DEMO':
                              return this.renderCondition('DEMO', '#FF8F28');
                            default:
                              return this.renderCondition('None', 'lightgrey');
                          }
                        }}
                      />
                      <Column
                        //{...this.getColumnSearchProps("actions")}
                        title="Actions"
                        render={(text, stock) => (
                          <span>
                            <Button
                              style={{
                                backgroundColor: '#F91700',
                                color: 'white',
                                borderRadius: '3em'
                              }}
                              onClick={e => this.handleEditStock(stock)}
                            >
                              Edit
                            </Button>
                            <Divider type="vertical" />
                            <DeleteFilled
                              style={{
                                backgroundColor: '#CFD5E3',
                                color: 'white',
                                padding: '0.5em',
                                borderRadius: '3em'
                              }}
                              data={stock._id}
                              onClick={this.handleDeleteStock}
                            />
                          </span>
                        )}
                      />
                    </StyledTable>
                  </TabPane>
                </StyledTabs>
              </Col>
            </Row>
          )}
        </Spin>
      </div>
    );
  }
}

const WrappedStock = Form.create()(Stock);
export default WrappedStock;
